var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInviteGift(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.3277 24.9356L1.3048 23.3366L0.918823 6.02295L23.5809 7.93443L20.3277 24.9356Z",
    fill: "url(#paint0_linear_340_3386)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0406 9.86439L0 7.84263L0.275695 4.58943C0.294074 4.27697 0.569773 4.05642 0.900607 4.0748L23.8016 5.98629C24.1141 6.02305 24.353 6.29873 24.3163 6.61119L24.0406 9.86439Z",
    fill: "#FFCC8A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5715 24.2741L8.93237 23.98L10.2006 8.70654L13.8397 9.00061L12.5715 24.2741Z",
    fill: "#FFCC8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7117 3.76221L18.3434 12.1617L15.7335 11.6471L15.0902 13.7791L12.2046 4.60768L13.7117 3.76221Z",
    fill: "#E04347"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7076 3.59717L5.75256 11.1144L8.41761 11.0409L8.69331 13.2281L13.0493 4.68156L11.7076 3.59717Z",
    fill: "#E04347"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.9324 2.99079C15.2373 2.34751 16.3033 1.99829 16.965 1.75936C18.7111 1.15283 18.7478 0.950654 19.097 1.06093C20.3101 1.46528 20.7696 4.38764 19.8138 6.42778C19.6484 6.81375 19.1338 7.91654 18.2148 8.0452C17.884 8.10034 17.645 8.00843 16.5055 7.32839C14.6308 6.20723 14.0243 5.71098 13.4545 5.01255C12.9766 4.38765 12.9031 4.05681 12.9766 3.78112C13.0685 3.41352 13.4177 3.22973 13.9324 2.99079Z",
    fill: "#F56265"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2854 2.75167C10.0907 1.90621 9.09818 1.39159 8.47327 1.06075C6.85587 0.16015 6.85586 -0.0604078 6.50665 0.0131108C5.23846 0.215287 4.3011 3.00899 4.88925 5.17779C5.0179 5.58214 5.33035 6.75844 6.21257 7.05251C6.52502 7.14441 6.76397 7.08927 8.01378 6.6114C10.0539 5.82107 10.734 5.45349 11.3956 4.82858C11.9838 4.29557 12.1124 3.98311 12.0757 3.70742C12.0573 3.33982 11.7265 3.08251 11.2854 2.75167Z",
    fill: "#F56265"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1675 4.25909L12.1859 3.9834C13.0313 4.14882 14.0422 4.27747 15.2001 4.31423C16.4867 4.33261 17.6262 4.20395 18.5268 4.03854C17.6079 4.24071 16.4867 4.40613 15.1817 4.44289C14.0238 4.47965 13.0129 4.38775 12.1675 4.25909Z",
    fill: "#E04347"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0569 3.59682L12.0753 3.39464C12.6266 3.56006 13.417 3.7071 14.3543 3.63358C15.8982 3.50493 16.9826 2.78812 16.9826 2.8065C16.9826 2.8065 15.8982 3.54168 14.336 3.74386C13.3986 3.85414 12.6083 3.72548 12.0569 3.59682Z",
    fill: "#E04347"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4617 3.63402L12.4801 3.43184C11.9103 3.48698 11.1016 3.52374 10.1827 3.2848C8.69391 2.89883 7.73818 2.0166 7.73818 2.0166C7.7198 2.03498 8.67553 2.93558 10.1827 3.39507C11.1016 3.65239 11.892 3.67078 12.4617 3.63402Z",
    fill: "#E04347"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1859 4.55331L12.1675 4.75548C12.7372 4.68197 13.546 4.66359 14.4466 4.88414C15.9537 5.27012 16.891 6.17071 16.9094 6.15233C16.9094 6.13395 15.9721 5.23336 14.4466 4.79225C13.546 4.51655 12.7372 4.49817 12.1859 4.55331Z",
    fill: "#E04347"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5899 4.57135L12.5715 4.79191C12.0201 4.62649 11.2298 4.46107 10.2925 4.53459C8.74856 4.68162 7.66417 5.38006 7.66417 5.38006C7.64579 5.36168 8.74857 4.62649 10.3108 4.44269C11.2482 4.33241 12.0385 4.44269 12.5899 4.57135Z",
    fill: "#E04347"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6449 4.29585L12.6633 4.02016C11.8178 4.05692 10.7885 4.02016 9.649 3.83636C8.36242 3.65256 7.27803 3.34011 6.41418 3.00928C7.27803 3.37687 8.36242 3.72608 9.649 3.9834C10.7702 4.20395 11.781 4.27747 12.6449 4.29585Z",
    fill: "#E04347"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7663 4.14867C13.6928 4.88385 13.0495 5.43525 12.3143 5.38011C11.5792 5.30659 11.0278 4.6633 11.0829 3.92811C11.1564 3.19292 11.7997 2.64153 12.5349 2.69667C13.2701 2.77019 13.8215 3.41348 13.7663 4.14867Z",
    fill: "#E04347"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_340_3386",
    x1: 8.67687,
    y1: -3.54531,
    x2: 35.7923,
    y2: 26.2825,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC545"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8F5C"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteGift);
export default __webpack_public_path__ + "static/media/invite-gift.360078c635ed0f030fce258024fa14f3.svg";
export { ForwardRef as ReactComponent };